"use client"

import { useEffect, useState } from "react"
import "./Legislative.css"

const Legislative = ({ language }) => {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    setIsVisible(true)
  }, [])

  const translations = {
    en: {
      heroTitle: "Legislative Work & Appropriations Committee",
      heroDescription:
        "Leading national development through strategic budget oversight, infrastructure projects, and legislative initiatives as Chairman of the House Committee on Appropriations.",
      federalProjectsTitle: "Major Federal Government Initiatives",
      legislativeProjects: [
        {
          title: "Budget Oversight",
          description:
            "He led his committee in September 2025 to an interactive session with the ministers of Finance and Budget to monitor the implementation of the 2025 Appropriations Act.",
          category: "Budget",
          categoryClass: "budget-category",
        },
        {
          title: "Infrastructure Development",
          description:
            "In August 2025, he highlighted key Tinubu administration projects, including the Abuja-Kaduna-Zaria-Kano expressway, the Kano-Hadeja Road, and the Kano Railway Bypass, with a total value of over ₦250 billion.",
          category: "Infrastructure",
          categoryClass: "infrastructure-category",
          amount: "₦250 Billion",
        },
        {
          title: "Solar Power Initiative",
          description:
            "He is involved in a plan to provide 24/7 solar power to all Nigerian tertiary institutions and teaching hospitals.",
          category: "Energy",
          categoryClass: "energy-category",
        },
        {
          title: "Kano Light Rail Project",
          description:
            "He announced in September 2025 that President Tinubu is expected to lay the foundation for a light rail project in Kano State.",
          category: "Infrastructure",
          categoryClass: "infrastructure-category",
        },
        {
          title: "Legislative Bills",
          description:
            "Bichi has sponsored bills like the University of Medicine and Health Sciences, Bichi (Establishment) Bill, 2021, and the Office of the Surveyor-General of the Federation (Establishment) Bill, 2021.",
          category: "Bills",
          categoryClass: "bills-category",
        },
        {
          title: "Tax Reform",
          description:
            "He is involved in efforts to pass tax reform bills aimed at increasing government revenue to fund infrastructure, education, and other sectors.",
          category: "Bills",
          categoryClass: "bills-category",
        },
        {
          title: "Federal Highway Projects",
          description:
            "As Chairman of Appropriations (and formerly Works), Bichi has overseen several national road upgrades. Key examples: the Abuja–Kaduna–Zaria–Kano Expressway (major sections now complete), and the Kano–Maiduguri and Kano–Katsina highways (several sections in progress). These multi-billion-naira projects improve regional connectivity.",
          category: "Infrastructure",
          categoryClass: "infrastructure-category",
        },
        {
          title: "Solar Power Installation (AKTH, Murtala, Nasarawa – 2025)",
          description:
            "The federal government, with Bichi's backing, installed solar panels at tertiary hospitals. At AKTH: 7 MW capacity (₦12 bn) was wired in mid-2025. Concurrently, 2 MW was allocated to Kano's Murtala Muhammed Specialist Hospital and 1 MW to Nasarawa Hospital (as part of a wider 'Renewed Hope' agenda). These systems are funded by FG budgets in 2024/25.",
          category: "Energy",
          categoryClass: "energy-category",
          amount: "₦12 Billion",
        },
        {
          title: "AKTH Equipment Upgrade (2025)",
          description:
            "₦26 billion was earmarked in the 2025 budget for AKTH to buy state-of-the-art medical equipment. (This covers a new Accident & Emergency block, cardiac care units, dialysis machines, etc.) Bichi confirmed FG approval of this funding when launching the solar project.",
          category: "Healthcare",
          categoryClass: "healthcare-category",
          amount: "₦26 Billion",
        },
        {
          title: "School Renovations",
          description:
            "Under Bichi's advocacy, the 2025 federal budget allocated ₦1.5 billion to renovate major Kano-area schools. This covers Dawakin Tofa Science College and Government Secondary School, Bichi. The same funds also include projects at GSS Dan CiCi (near Bichi). In addition, the FG will rebuild Hagagawa Primary School (Bichi LGA capital) and renovate six other primaries (Chiranchi, Sabon Layyi, etc.), ensuring roofs, classrooms, and hostels are refurbished.",
          category: "Infrastructure",
          categoryClass: "infrastructure-category",
          amount: "₦1.5 Billion",
        },
      ],
      achievementsTitle: "Achievements as Chairman of the House Committee On Appropriations",
      achievements: [
        {
          title: "Budget Transparency and Equity",
          description:
            "Equitable distribution of funds: One supporting publication praised Bichi for ensuring a more equitable distribution of budgetary allocations, moving away from a previous system where only privileged members received large allocations. Focus on essential expenditures: According to the same source, Bichi's committee prioritized essential expenditures and efficiently reallocated resources to optimize fund utilization and align with long-term national goals.",
        },
        {
          title: "Budget Monitoring and Oversight",
          description:
            "Accountability for budget performance: In September 2025, Bichi led the committee in an interactive session with key ministers and officials, including the Minister of Finance, Wale Edun, to monitor the implementation of the 2025 Appropriation Act. Ensuring effective service delivery: The session with finance officials was part of the National Assembly's constitutional mandate to oversee budget performance and ensure efficient service delivery across federal government ministries, departments, and agencies.",
        },
        {
          title: "Facilitating the Passage of the Supplementary Budget",
          description:
            "Calculations for the new minimum wage: In September 2025, during the passage of a supplementary budget, Bichi confirmed that calculations were carefully made using data from the Accountant General of the Federation to ensure the approved ₦3 trillion was sufficient to cover the ₦70,000 minimum wage until December 31.",
        },
      ],
    },
    ha: {
      heroTitle: "Aikin Majalisa da Kwamitin Kasafin Kudi",
      heroDescription:
        "Jagorantar ci gaban kasa ta hanyar sa ido kan kasafin kudi, ayyukan gine-gine, da shirye-shiryen majalisa a matsayinsa na Shugaban Kwamitin Kasafin Kudi na Majalisar.",
      federalProjectsTitle: "Manyan Shirye-shiryen Gwamnatin Tarayya",
      legislativeProjects: [
        {
          title: "Sa Ido kan Kasafin Kudi",
          description:
            "Ya jagoranci kwamitin sa a watan Satumba 2025 zuwa zaman tattaunawa da ministocin Kudi da Kasafin Kudi don sa ido kan aiwatar da Dokar Kasafin Kudi ta 2025.",
          category: "Kasafin Kudi",
          categoryClass: "budget-category",
        },
        {
          title: "Ci Gaban Gine-gine",
          description:
            "A watan Agusta 2025, ya bayyana muhimman ayyukan gwamnatin Tinubu, ciki har da babbar hanyar Abuja-Kaduna-Zaria-Kano, Hanyar Kano-Hadeja, da Kano Railway Bypass, da darajar sama da Naira biliyan 250.",
          category: "Gine-gine",
          categoryClass: "infrastructure-category",
          amount: "₦250 Biliyan",
        },
        {
          title: "Shirin Wutar Rana",
          description:
            "Yana cikin shirin samar da wutar rana na sa'o'i 24/7 ga duk jami'o'in Najeriya da asibitocin koyarwa.",
          category: "Makamashi",
          categoryClass: "energy-category",
        },
        {
          title: "Aikin Jirgin Kasa na Kano",
          description:
            "Ya sanar a watan Satumba 2025 cewa ana sa ran Shugaba Tinubu ya kafa tushen aikin jirgin kasa a Jihar Kano.",
          category: "Gine-gine",
          categoryClass: "infrastructure-category",
        },
        {
          title: "Kudurori na Majalisa",
          description:
            "Bichi ya gabatar da kudurori kamar Jami'ar Likitanci da Kimiyyar Lafiya, Bichi (Kafa) Bill, 2021, da Ofishin Babban Mai Auna Kasa na Tarayya (Kafa) Bill, 2021.",
          category: "Kudurori",
          categoryClass: "bills-category",
        },
        {
          title: "Gyaran Haraji",
          description:
            "Yana cikin kokarin zartar da kudurori na gyaran haraji da nufin kara kudaden shiga na gwamnati don tallafa wa gine-gine, ilimi, da sauran fannoni.",
          category: "Kudurori",
          categoryClass: "bills-category",
        },
        {
          title: "Ayyukan Manyan Hanyoyi na Tarayya",
          description:
            "A matsayinsa na Shugaban Kasafin Kudi (da kuma tsohon Shugaban Ayyuka), Bichi ya kula da inganta hanyoyi da yawa na kasa. Misalai: Babbar Hanyar Abuja–Kaduna–Zaria–Kano (manyan sassa sun kammala), da hanyoyin Kano–Maiduguri da Kano–Katsina (sassa da yawa suna ci gaba). Wadannan ayyuka masu darajar biliyoyin Naira suna inganta hada-hadar yanki.",
          category: "Gine-gine",
          categoryClass: "infrastructure-category",
        },
        {
          title: "Shigar da Wutar Rana (AKTH, Murtala, Nasarawa – 2025)",
          description:
            "Gwamnatin tarayya, tare da goyon bayan Bichi, ta shigar da na'urorin wutar rana a asibitocin koyarwa. A AKTH: karfin MW 7 (Naira biliyan 12) an hada shi a tsakiyar 2025. A lokaci guda, an keɓe MW 2 ga Asibitin Murtala Muhammed na Kano da MW 1 ga Asibitin Nasarawa (a matsayin wani bangare na babban shirin 'Renewed Hope'). Wadannan tsarin ana tallafa musu ta hanyar kasafin kudin FG a 2024/25.",
          category: "Makamashi",
          categoryClass: "energy-category",
          amount: "₦12 Biliyan",
        },
        {
          title: "Inganta Kayan Aikin AKTH (2025)",
          description:
            "An keɓe Naira biliyan 26 a cikin kasafin kudin 2025 ga AKTH don siyan kayan aikin likitanci na zamani. (Wannan ya shafi sabon ginin Gaggawa da Jinyar, sassan kula da zuciya, injunan dialysis, da sauransu.) Bichi ya tabbatar da amincewar FG na wannan tallafi lokacin kaddamar da aikin wutar rana.",
          category: "Lafiya",
          categoryClass: "healthcare-category",
          amount: "₦26 Biliyan",
        },
        {
          title: "Gyaran Makarantu",
          description:
            "A karkashin shawarar Bichi, kasafin kudin tarayya na 2025 ya keɓe Naira biliyan 1.5 don gyara manyan makarantu na yankin Kano. Wannan ya shafi Kwalejin Kimiyya ta Dawakin Tofa da Makarantar Sakandare ta Gwamnati, Bichi. Wannan kudin ya kuma hada da ayyuka a GSS Dan CiCi (kusa da Bichi). Bugu da kari, FG za ta sake gina Makarantar Firamare ta Hagagawa (babban birnin Bichi LGA) da gyara wasu makarantu firamare shida (Chiranchi, Sabon Layyi, da sauransu), tare da tabbatar da gyaran rufin, ajujuwa, da wuraren kwana.",
          category: "Gine-gine",
          categoryClass: "infrastructure-category",
          amount: "₦1.5 Biliyan",
        },
      ],
      achievementsTitle: "Nasarori a matsayinsa na Shugaban Kwamitin Kasafin Kudi na Majalisar",
      achievements: [
        {
          title: "Bayyana Kasafin Kudi da Adalci",
          description:
            "Rarraba kudade cikin adalci: Wata wallafa ta yaba wa Bichi don tabbatar da rarraba kasafin kudi cikin adalci, ta bar tsarin da kawai 'yan kadan masu gata suke samun babban rabo. Mayar da hankali kan muhimman kashe-kashe: Bisa ga wannan majiya, kwamitin Bichi ya ba da fifiko ga muhimman kashe-kashe kuma ya sake rarraba albarkatu yadda ya kamata don inganta amfani da kudade da kuma daidaita da dogon lokaci na burin kasa.",
        },
        {
          title: "Sa Ido da Kula da Kasafin Kudi",
          description:
            "Lissafi don aikin kasafin kudi: A watan Satumba 2025, Bichi ya jagoranci kwamitin a zaman tattaunawa da manyan ministoci da jami'ai, ciki har da Ministan Kudi, Wale Edun, don sa ido kan aiwatar da Dokar Kasafin Kudi ta 2025. Tabbatar da ingantaccen hidimar jama'a: Zaman da jami'an kudi wani bangare ne na aikin Majalisar da kundin tsarin mulki ya ba ta na sa ido kan aikin kasafin kudi da tabbatar da ingantaccen hidimar jama'a a duk ma'aikatun, sassan da hukumomin gwamnatin tarayya.",
        },
        {
          title: "Sauƙaƙe Zartar da Ƙarin Kasafin Kudi",
          description:
            "Lissafi don sabon mafi karancin albashi: A watan Satumba 2025, yayin zartar da ƙarin kasafin kudi, Bichi ya tabbatar da cewa an yi lissafi a hankali ta amfani da bayanan daga Babban Lissafin Tarayya don tabbatar da cewa Naira tiriliyan 3 da aka amince da shi ya isa ya rufe mafi karancin albashi na Naira 70,000 har zuwa ranar 31 ga Disamba.",
        },
      ],
    },
  }

  const t = translations[language]

  return (
    <div className="legislative">
      {/* Hero Section */}
      <section className="legislative-hero">
        <div className={`legislative-hero-content ${isVisible ? "fade-in" : ""}`}>
          <h1>{t.heroTitle}</h1>
          <p>{t.heroDescription}</p>
        </div>
      </section>

      {/* Legislative Content */}
      <div className="legislative-content">
        {/* Federal Projects Section */}
        <section className={`${isVisible ? "slide-in-up" : ""}`}>
          <h2 className="section-title">{t.federalProjectsTitle}</h2>

          <div className="legislative-grid">
            {t.legislativeProjects.map((project, index) => (
              <div key={index} className="legislative-card">
                {/* Removed legislative-number and legislative-category */}
                <h3 className="legislative-title">{project.title}</h3>
                <p className="legislative-description">{project.description}</p>
                {/* Removed legislative-amount */}
              </div>
            ))}
          </div>
        </section>

        {/* Achievements Section */}
        <section className={`achievements-section ${isVisible ? "fade-in" : ""}`}>
          <div className="achievements-content">
            <h2 className="achievements-title">{t.achievementsTitle}</h2>

            <div className="achievements-grid">
              {t.achievements.map((achievement, index) => (
                <div key={index} className="achievement-item">
                  <h4>{achievement.title}</h4>
                  <p>{achievement.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
    </div>
  )
}

export default Legislative
